import { Navigate } from "react-router-dom";
import { PageError, PageLoading } from "@/components/loading/PageLoading/PageLoading";
import { useAuthContextValueHook } from "@/contexts/AuthContext";
import { useUserPageQuery } from "@/hooks/ReactQuery/UserPageReactQuery/UserPageReactQuery";

/**
 * 관리자 첫 화면(/): 상황에 맞는 화면으로 바로 보낸다.
 * 로그아웃 → 로그인, 페이지 있음 → 마이 페이지, 페이지 없음 → 페이지 만들기 (소개 랜딩은 공개 사이트 shool.uk 에 있음)
 */
export default function Component(props) {
    const authContextValueHook = useAuthContextValueHook();

    const { data: userPageData, isLoading: userPageDataIsLoading, isError: userPageDataIsError, refetch: refetchUserPage } = useUserPageQuery({
        isLoggedIn: authContextValueHook?.isLoggedIn,
        isReady: authContextValueHook?.isReady,
        accessToken: authContextValueHook?.accessToken
    });

    if (!authContextValueHook?.isReady || (authContextValueHook?.isLoggedIn && userPageDataIsLoading)) {
        return <PageLoading />;
    }

    if (!authContextValueHook?.isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    // 서버 오류를 '페이지 없음' 으로 오해해 페이지 만들기로 보내지 않는다
    if (userPageDataIsError) {
        return <PageError onRetry={() => refetchUserPage()} />;
    }

    const userPage = userPageData?.data?.content;
    return <Navigate to={userPage?.id ? `/mypage/${userPage.id}` : '/create/mypage'} replace />;
}
